import React, { useEffect, useState } from "react";
import { Grid2x2, Megaphone, ChevronLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchNotifications,
  markNotificationsRead,
} from "../../Store/Actions/NotificationActions";

const MainNotification = ({ onBack }) => {
  const dispatch = useDispatch();
  const { notifications, loading } = useSelector(
    (state) => state.notifications
  );
  const [switchLayout, setSwitchLayout] = useState(false);

  useEffect(() => {
    dispatch(fetchNotifications());
  }, [dispatch]);

  const handleToggle = () => {
    setSwitchLayout((prev) => !prev);
  };

  const handleMarkAllRead = () => {
    dispatch(markNotificationsRead([], true));
  };

  const handleMarkOneRead = (id) => {
    dispatch(markNotificationsRead([id]));
  };

  const formatDate = (dateStr) => {
    const d = new Date(dateStr);
    return d.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
    });
  };

  return (
    <div className="w-full mb-5">
      <div className="flex items-center">
        <div className="flex items-center">
          <Link to={"/dashboard"}>
            <ChevronLeft />
          </Link>
          <div className="ml-4">
            <p className="font-popinsSemiBold text-xl">Notification</p>
            <p className="font-popinsRegular text-sm text-black/50">
              Manage and view all your notifications here.
            </p>
          </div>
        </div>
      </div>
      <div className="">
        <div className="bg-white rounded-xl">
          <div className="pt-5 h-full">
            <div className="flex justify-between items-center">
              <button
                onClick={handleMarkAllRead}
                className="text-sm text-themeColor font-popinsMedium underline"
              >
                Mark all as read
              </button>
              <button
                className="border-[#6F6F6F]/70 border rounded-md flex items-center justify-center px-4 h-8 text-xs font-popinsMedium text-[#6F6F6F]"
                onClick={handleToggle}
              >
                <Grid2x2 color="#6F6F6F" size={15} />
                <span className="pl-2">Switch layout</span>
              </button>
            </div>
            <div className="w-full mt-6">
              {loading ? (
                <div className="flex flex-wrap justify-between">
                  {Array.from({ length: 6 }).map((_, i) => (
                    <div
                      key={i}
                      className={`${switchLayout ? "w-full" : "w-[49%]"} my-2 py-3 flex pl-4 items-center rounded-md bg-slate-50`}
                    >
                      <div className="bg-gray-200 rounded-full p-3 w-11 h-11 animate-pulse" />
                      <div className="p-2 flex-1 space-y-2">
                        <div className="h-4 bg-gray-200 rounded animate-pulse w-2/3" />
                        <div className="h-3 bg-gray-200 rounded animate-pulse w-full" />
                        <div className="h-3 bg-gray-200 rounded animate-pulse w-1/3" />
                      </div>
                    </div>
                  ))}
                </div>
              ) : notifications.length === 0 ? (
                <p className="text-center py-8 text-gray-400 font-popinsRegular">
                  No notifications yet
                </p>
              ) : (
                <div className="flex flex-wrap justify-between">
                  {notifications.map((item) => (
                    <div
                      key={item.id}
                      onClick={() => !item.isRead && handleMarkOneRead(item.id)}
                      className={`${
                        switchLayout ? "w-full" : "w-[49%]"
                      } my-2 py-2 flex pl-4 items-center rounded-md relative cursor-pointer ${
                        item.isRead
                          ? "bg-slate-50"
                          : "bg-blue-50 border-l-4 border-themeColor"
                      }`}
                    >
                      <div className="bg-themeColor/10 rounded-full p-3">
                        <Megaphone size={22} />
                      </div>

                      <div className="p-2 flex-1">
                        <p className="font-popinsMedium text-base">
                          {item.title}
                        </p>
                        <p className="font-popinsRegular text-black/70 text-sm">
                          {item.body}
                        </p>
                        <p className="font-popinsRegular text-black/50 text-xs">
                          {formatDate(item.createdAt)}
                        </p>
                      </div>

                      {!item.isRead && (
                        <div className="w-2 h-2 rounded-full bg-themeColor mr-3" />
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainNotification;
